export default __webpack_public_path__ + "static/media/gradingIcon4.88be06d1.png";